Vue.component('container_template',             require('./templates/container.vue').default);
Vue.component('pie_chart',                      require('./templates/pie_chart.vue').default);
